"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentryUtilGetClient = exports.SentryUtilGetEnvironment = exports.SentryUtilCleanURI = void 0;
const DOM_1 = require("../DOM");
const SentryUtilCleanURI = (uri) => {
    const regex = /do=([a-zA-Z\-]+)/gm;
    let m = regex.exec(uri);
    if (!m || !m[1]) {
        return uri.replace(window.location.href, '');
    }
    return m[1];
};
exports.SentryUtilCleanURI = SentryUtilCleanURI;
const SentryUtilGetEnvironment = () => {
    return parseInt(DOM_1.DOM.Parser.getDataByNameFromElement('env', DOM_1.DOM.Parser.getBodyElement()));
};
exports.SentryUtilGetEnvironment = SentryUtilGetEnvironment;
const SentryUtilGetClient = () => {
    const client = DOM_1.DOM.Parser.getDataByNameFromElementOrNull('client', DOM_1.DOM.Parser.getBodyElement());
    if (!client) {
        return undefined;
    }
    const sessionClient = client ? JSON.parse(client) : null;
    const clientName = sessionClient.firstName && sessionClient.lastName
        ? `${sessionClient.firstName} ${sessionClient.lastName}`
        : (sessionClient.company ? sessionClient.company : sessionClient.id);
    const clientEmail = sessionClient.emailList && sessionClient.emailList[0]
        ? sessionClient.emailList[0]
        : undefined;
    return { name: clientName, email: clientEmail, id: sessionClient.id };
};
exports.SentryUtilGetClient = SentryUtilGetClient;
